export default "__VITE_PUBLIC_ASSET__f8995a7f__"